import { PageEventIds } from '@agoda/analytics-messages-definition-activities';
import { PageTypes } from 'core/constant/analytics/PageTypes';
import { MobilePageTypes } from 'core/constant/analytics/MobilePageTypes';
import { WebViewPageTypes } from 'core/constant/analytics/WebViewPageType';
import { ActivitiesHomePageDesktopVisitEventManifestV2 } from '@agoda/analytics-messages-definition-activities/manifest/activities-home-page-desktop';
import { WebActivitiesSearchVisitEventManifestV3 } from '@agoda/analytics-messages-definition-activities/manifest/activities-search-page-desktop';
import { WebActivitiesDetailVisitEventManifestV2 } from '@agoda/analytics-messages-definition-activities/manifest/activities-details-page-desktop';
import { MobWebActivitiesHomeVisitEventManifestV2 } from '@agoda/analytics-messages-definition-activities/manifest/activities-home-page-mobile';
import { MobWebActivitiesSearchVisitEventManifestV2 } from '@agoda/analytics-messages-definition-activities/manifest/activities-search-page-mobile';
import { MobWebActivitiesDetailVisitEventManifestV2 } from '@agoda/analytics-messages-definition-activities/manifest/activities-details-page-mobile';
import { WebViewActivitiesHomeVisitEventManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/activities-home-page-web-view';
import { WebViewActivitiesSearchVisitEventManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/activities-search-page-web-view';
import { WebViewActivitiesDetailVisitEventManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/activities-detail-page-web-view';
import { WebActivitiesCityVisitEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/activities-city-page-desktop';
import { MobWebActivitiesCityVisitEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/activities-city-page-mobile';
import { WebViewActivitiesCityVisitEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/activities-city-page-web-view';
import {
    ActivitiesCityPageDesktopActivitiesContextFieldsV1,
    ActivitiesCityPageMobileActivitiesContextFieldsV1,
    ActivitiesCityPageWebViewActivitiesContextFieldsV1,
    ActivitiesDetailPageDesktopContextFieldsV2,
    ActivitiesDetailPageMobileContextFieldsV2,
    ActivitiesDetailPageWebViewContextFieldsV1,
    ActivitiesHomePageDesktopContextFieldsV3,
    ActivitiesHomePageMobileContextFieldsV1,
    ActivitiesHomePageWebViewContextFieldsV1,
    ActivitiesSearchPageDesktopActivitiesContextFieldsV6,
    ActivitiesSearchPageMobileActivitiesContextFieldsV6,
    ActivitiesSearchPageWebViewActivitiesContextFieldsV6,
} from '@agoda/analytics-messages-definition-activities/contexts.split';
import { logError } from 'core-framework/util/LogMessage';
import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';

export type HomePageContextFields = ActivitiesHomePageDesktopContextFieldsV3 | ActivitiesHomePageMobileContextFieldsV1 | ActivitiesHomePageWebViewContextFieldsV1;

export type SearchPageContextFields =
    | ActivitiesSearchPageDesktopActivitiesContextFieldsV6
    | ActivitiesSearchPageMobileActivitiesContextFieldsV6
    | ActivitiesSearchPageWebViewActivitiesContextFieldsV6;

export type DetailsPageContextFields = ActivitiesDetailPageDesktopContextFieldsV2 | ActivitiesDetailPageMobileContextFieldsV2 | ActivitiesDetailPageWebViewContextFieldsV1;

export type CityPageContextFields =
    | ActivitiesCityPageDesktopActivitiesContextFieldsV1
    | ActivitiesCityPageMobileActivitiesContextFieldsV1
    | ActivitiesCityPageWebViewActivitiesContextFieldsV1;

export const getPageEventIds = (pageTypeId: ActivitiesPageTypes): PageEventIds => {
    switch (pageTypeId) {
        case PageTypes.Home:
            return ActivitiesHomePageDesktopVisitEventManifestV2.ids;
        case PageTypes.Search:
            return WebActivitiesSearchVisitEventManifestV3.ids;
        case PageTypes.Details:
            return WebActivitiesDetailVisitEventManifestV2.ids;
        case PageTypes.City:
            return WebActivitiesCityVisitEventActivitiesManifestV1.ids;
        case MobilePageTypes.Home:
            return MobWebActivitiesHomeVisitEventManifestV2.ids;
        case MobilePageTypes.Search:
            return MobWebActivitiesSearchVisitEventManifestV2.ids;
        case MobilePageTypes.Details:
            return MobWebActivitiesDetailVisitEventManifestV2.ids;
        case MobilePageTypes.City:
            return MobWebActivitiesCityVisitEventActivitiesManifestV1.ids;
        case WebViewPageTypes.Home:
            return WebViewActivitiesHomeVisitEventManifestV1.ids;
        case WebViewPageTypes.Search:
            return WebViewActivitiesSearchVisitEventManifestV1.ids;
        case WebViewPageTypes.Details:
            return WebViewActivitiesDetailVisitEventManifestV1.ids;
        case WebViewPageTypes.City:
            return WebViewActivitiesCityVisitEventActivitiesManifestV1.ids;
        default:
            logError(`getPageEventIds: Unknown pageTypeId: ${pageTypeId}`, pageTypeId, { pageTypeId: String(pageTypeId) });
            // The code should never reach this case
            return { page_type_id: pageTypeId } as PageEventIds;
    }
};
